import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { GridConfig } from '@inavista/components/grid';

// Shipment adjustment order popup → Exceptions on @inavista/components. Same columns, labels, order, default
// visibility, widths, date format, Reason pill, links (Shipment Order Id, Item, Item Description) and toolbar
// (Columns, Search, Excel export for AllGrid_Toolbar_Excel_Export, Clear filters) as the Syncfusion grid it replaces.
// Rows are the popup's own data.electronicAdjustmentOrderLines (LocalRowsGridApi). No paging (Martin).

export const SHIPMENT_ADJUSTMENT_EXCEPTIONS_URL = 'page://shipment-adjustment-exceptions';
export const SHIPMENT_ADJUSTMENT_EXCEPTIONS_PERSISTENCE_KEY = 'rims.service.shipment-adjustment-order-exceptions';

export const SHIPMENT_ADJUSTMENT_EXCEPTIONS_COLUMNS: [string, string][] = [
  ['__rowKey', 'int'],
  ['shoExceptionId', 'nvarchar'],
  ['line', 'int'],
  ['shipmentOrderId', 'nvarchar'],
  ['itemCode', 'nvarchar'],
  ['itemDescription', 'nvarchar'],
  ['serviceItemGroup', 'nvarchar'],
  ['quantity', 'decimal'],
  ['reasonDescription', 'nvarchar'],
  ['createdDate', 'datetime'],
  ['createdBy', 'nvarchar'],
];

const SHOWN = SHIPMENT_ADJUSTMENT_EXCEPTIONS_COLUMNS.map(([c]) => c).filter(c => c !== '__rowKey' && c !== 'shoExceptionId');

export function buildShipmentAdjustmentExceptionsGridConfig(canExport: boolean, statusColor: (value: unknown) => string): GridConfig {
  return {
    apiBaseUrl: SHIPMENT_ADJUSTMENT_EXCEPTIONS_URL,
    clientSide: true,
    // The page numbers the rows (shoExceptionId may be missing on a line).
    keyColumn: '__rowKey',
    rowHeight: 30,
    defaultColumnOrder: SHOWN,
    // The row key was hidden and out of the column chooser.
    hiddenByDefaultColumns: ['__rowKey', 'shoExceptionId'],
    startHiddenColumns: ['line', 'serviceItemGroup', 'createdDate', 'createdBy'],
    columnLabels: {
      line: 'Order Line Id', shipmentOrderId: 'Shipment Order Id', itemCode: 'Item', itemDescription: 'Item Description',
      serviceItemGroup: 'Service Item Group', quantity: 'Quantity', reasonDescription: 'Reason', createdDate: 'Created Date',
      createdBy: 'Created By',
    },
    // Every column left, as the old grid (no textAlign).
    columnAlign: Object.fromEntries(SHOWN.map(c => [c, { horizontal: 'left' as const, header: { horizontal: 'left' as const } }])),
    // The old widths; the others had none and shared the rest.
    columnWidths: Object.fromEntries(SHOWN.map(c => [c, ({ line: 100, quantity: 100, createdDate: 220 } as Record<string, number>)[c] ?? 150])),
    stretchColumns: true,
    columnSizing: { line: { noStretch: true }, quantity: { noStretch: true }, createdDate: { noStretch: true } },
    columnTypes: { createdDate: 'datetime' },
    columnDateFormats: { createdDate: 'd MMM, yyyy hh:mm a' },
    // Syncfusion's 'n': grouped, up to 3 decimals.
    columnNumberFormats: { line: { maximumFractionDigits: 3 }, quantity: { maximumFractionDigits: 3 } },
    hyperlinkColumns: ['shipmentOrderId', 'itemCode', 'itemDescription'],
    excelFilterColumns: ['serviceItemGroup'],
    columnColors: { reasonDescription: statusColor },
    enableColumnsPicker: true,
    enableExport: canExport,
    enableSavedViews: false,
    enableScrollButtons: false,
    enableFitColumns: false,
    enableResetLayout: true,
    enableRefresh: false,
    enableFooter: false,
    multiSort: true,
    emptyStateMessage: 'No records to display',
    // Right-click a cell filters by its value (Martin, 2026-10-29: every grid that filters).
    enableContextMenuFilter: true,
    persistenceKey: SHIPMENT_ADJUSTMENT_EXCEPTIONS_PERSISTENCE_KEY,
    firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  };
}
